"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bab(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M17.0775 10.9688H20.73L21 9.46875H17.4675C16.7711 9.49042 16.0961 9.71455 15.525 10.1138C15.315 9.36375 13.275 9.46875 13.275 9.46875L13.545 7.96875H12.75L12.48 9.46875H11.6475L11.88 7.96875H11.0175L10.7025 9.46875H9.81L9.3525 11.8088L8.745 9.51375H6.75L3 15.0263H6.09L6.405 13.5638H5.775L7.575 10.9313L8.25 13.5788H7.575L7.2825 15.0263H9.5775L9.39 16.0313H10.29L10.5 15.0263H11.25L11.0625 16.0313H12L12.1875 15.0263H13.3575C13.8955 14.9652 14.3935 14.7123 14.76 14.3138C15.197 14.756 15.7885 15.0114 16.41 15.0263H19.9425L20.175 13.5638H17.0025C14.82 13.5263 15.75 10.9538 17.0775 10.9688ZM13.11 13.5263H10.77L10.9575 12.8138H13.2075C13.7775 12.8513 13.59 13.5263 13.11 13.5263ZM13.4625 11.6063H11.1225L11.31 10.8938H13.56C14.13 10.9313 13.92 11.6363 13.4625 11.6363V11.6063Z", fill: color }));
}
exports["default"] = bab;
//# sourceMappingURL=bab.js.map